function findOne(haystack, arr) {
    return arr.some(function (v) {
        return haystack.indexOf(v) >= 0;
    });
};
function applyDiscount(total, data) {
  return data.attributes.type === "percentage" ? total * (parseFloat(data.attributes.value) / 100) : parseFloat(data.attributes.value);
}

function applyDiscountCollection(data) {
  var product = null;
  window.cart.forEach(function(obj){
    var collections = obj.collections.map((function(c) {return btoa("gid://shopify/Collection/"+c.id)}));
    var exist = findOne(data.attributes.allocationValues, collections);
    if (exist) {
    	product = obj;
    }
  });
  if (product) {
    var total = parseInt(product.quantity) * parseFloat(product.price);
  	return applyDiscount(total, data).toFixed(2);
  }
  return null;
}

function applyDiscountCustomer(data) {
   var customerIdBtoa = window.customerId.toString();
   var ids = data.attributes.allocationValues.map(function(obj){
    	var id = atob(obj.id);
    	return id.replace('gid://shopify/Customer/', '')
   });
   if (ids.includes(customerIdBtoa)) {
     return applyDiscount(window.total ? window.total : window.cartTotal, data).toFixed(2);
   }
   return null;
}

function showDiscountTotalRow() {
	var discountTotalRow = $('tr.order-discount');
  	var totalDiscountPriceRule = window.totalPriceRuleDiscount ? parseFloat(window.totalPriceRuleDiscount): 0;
  	var totalDiscountCode = window.totalDiscountCode ? parseFloat(window.totalDiscountCode): 0;
  	console.log('ASD ' + totalDiscountPriceRule);
  	console.log('dsa ' + totalDiscountCode);
  	var span = discountTotalRow.find('#bk-cart-subtotal-discount');
  	var total = (totalDiscountPriceRule + totalDiscountCode).toFixed(2);
  	span.html('$'+total);
  	discountTotalRow.show();
}

function showDiscount(discount) {
  if (discount > 0) {
  	var subTotalEl = $('.cart-subtotal span#bk-cart-subtotal-price');
  	var totalEl = $('.order-total span#bk-cart-total-price');
  	var totalWithDiscount = (window.cartTotal - discount).toFixed(2);
  	totalEl.html('$' + totalWithDiscount);
  	window.totalDiscountCode = discount;
  }
  
}

function applyDiscountType(data) {
  var discount = null;
  switch(data.attributes.allocation) {
    case "all":
      console.log(window.cartTotal);
      discount = applyDiscount(window.cartTotal,data).toFixed(2);
      break;
    case "customer":
      discount = applyDiscountCustomer(data);
      break;
    case "collection":
      discount = applyDiscountCollection(data);
      break;
  }
  if (discount && discount > 0) {
    window.discount = discount;
  	showDiscount(discount);
    showDiscountTotalRow();

  }
}

function checkDiscountDate(data) {
	return (
      new Date() >= Date.parse(data.attributes.startDate.replace(/-/g, "/"))
      && new Date() <= Date.parse(data.attributes.endDate.replace(/-/g, "/")))
}

function getDiscountObj(code){
	var query = [{"attribute": "name", "operator": "==", "value": code}]
    $.get(window.apiURL + "/collections/discountcodes", {
      where: JSON.stringify(query)
    }, function( response ) {
      if (response.data.length > 0 && checkDiscountDate(response.data[0])) {
        applyDiscountType(response.data[0]);
      }
    });

}


function checkDiscount(e) {
  e.preventDefault();
  var text = $('#discount').val();
  if (text.length >= 1) {
  	getDiscountObj(text);
  }
  
}

$(function() {
  $('#discountButton').click(checkDiscount);
});